import { Component } from '@angular/core';

@Component({
  selector: 'lib-row-card',
  imports: [],
  templateUrl: './row-card.component.html',
  styleUrl: './row-card.component.scss',
})
export class RowCardComponent {}
